import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setTabLayModalVisible, updateAreaList } from 'Store/ZoneSetting/action';
import HotKeysModal from 'Components/HotKeysModal';
import { langCheck } from 'Pub/js/utils';
import _ from 'lodash';
import ButtonCreate from 'Components/ButtonCreate';
import { checkAreaType } from '../../events';
import LaySetContent from './LaySetContent';
import './index.less';
import platform from 'Pub/js/platform';
const { NCTabs } = platform.base;
const { NCTabPane } = NCTabs;
const DEFAULT_TAB_NAME = 'DEFAULT_TAB_NAME';
class TabLaySetModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTabKey: '',
            tabKeyArr: [],
            tabListData: {},
        };
    }

    componentDidMount() {
        this.initTabList();
    }

    //初始化头部页签数据
    initTabList = () => {
        const { newAreaList } = this.props;
        const notNullAreaList = newAreaList.filter(item => item !== null);
        //获取tabheadcode
        const getTabHeadCodeList = (data, tabheadcodeList = []) => {
            data.map(item => {
                if (!item) {return;}
                if (item.areatype === '2' && item.tabheadcode) {
                    tabheadcodeList.push(item.tabheadcode);
                }
                if (item.tabs) {
                    getTabHeadCodeList(item.tabs, tabheadcodeList);
                }
                // if (item.grandsons) {
                //     getTabHeadCodeList(item.grandsons, tabheadcodeList);
                // }
            });
            return [...new Set(tabheadcodeList)];
        };
        const tabheadcodeList = getTabHeadCodeList(notNullAreaList);
        const tabGrandsonAreas = notNullAreaList.filter(item => this.isGrandsonTab(item)); //有多页签孙表的区域
        const tabGrandsonCodes = tabGrandsonAreas.map(item => item && item.code);
        const mainAreaCode = [DEFAULT_TAB_NAME].concat(
            tabheadcodeList.filter(item => item !== tabheadcodeList[0]),
        ); //主表和第一个多页签子表合并成一个页签
        const tabCodeList = mainAreaCode.concat(tabGrandsonCodes);
        let privateAreaList = _.cloneDeep(
            notNullAreaList.filter(
                area =>
                    area.tabs ||
                    area.tabheadcode ||
                    tabheadcodeList.includes(area.code) ||
                    area.code === area.headcode ||
                    this.isGrandsonTab(area),
            ),
        );
        let tabKeyArr = tabCodeList
            .map(code => {
                const targetArea = notNullAreaList.find(item => item.code === code);
                if (code === DEFAULT_TAB_NAME) {
                    return { name: this.props.zoneFormData.name, code };
                } else if (targetArea) {
                    let name = targetArea.name;
                    //有孙表的表格区
                    if (targetArea.grandsons) {
                        //有侧拉显示侧拉名称，没侧拉显示子表名称
                        const sideArea =
                            targetArea.sides &&
                            targetArea.sides.find(item => checkAreaType.isSide(item));
                        if (sideArea) {name = sideArea.name;}
                    }
                    return { name, code };
                }
            })
            .filter(item => item);
        //获取页签所有数据
        const getTabListData = tabCodeList => {
            let result = {};
            const getLaneItem = area => {
                let laneItem = [];
                const tabKey = area && area.tabs ? 'tabs' : area.formTabs ? 'formTabs' : 'tabs';
                if (area[tabKey]) {
                    laneItem.push(area);
                    area[tabKey].map(tab => {
                        laneItem.push(tab);
                    });
                } else {
                    laneItem.push(area);
                }
                return laneItem;
            };
            const getListData = (data, tab, tmpArr = []) => {
                const tabArea = tab !== DEFAULT_TAB_NAME && notNullAreaList.find(item => item.code === tab); //页签对应的区域
                data.forEach(item => {
                    const laneItem = getLaneItem(item);
                    //主子表
                    if (tab === DEFAULT_TAB_NAME) {
                        if (
                            item.areatype === '1' ||
                            item.code === tabheadcodeList[0] ||
                            item.tabheadcode === tabheadcodeList[0]
                        ) {
                            tmpArr.push(this.createLaneItem(laneItem));
                        }
                    } else if (
                        item.areatype === '2' &&
                        item.code !== tabheadcodeList[0] &&
                        (item.code === tab || item.tabheadcode === tab)
                    ) {
                        if(tabArea && tabArea.grandsons && tabArea.grandsons.length) { //孙表页签
                            //多页签孙表
                            if (this.isGrandsonTab(item)) {
                                const grandsonTabHeadcode = getTabHeadCodeList(item.grandsons);
                                const sideArea = item.sides && item.sides.find(side => checkAreaType.isSide(side));
                                //有侧拉把侧拉区显示出来
                                if(sideArea) {tmpArr.push(this.createLaneItem(sideArea));}
                                getListData(item.grandsons, grandsonTabHeadcode[0], tmpArr); //默认孙表只有一组多页签
                            }
                        } else {
                            tmpArr.push(this.createLaneItem(laneItem));

                        }
                    }
                });
                return tmpArr;
            };
            tabCodeList.forEach(tab => {
                result[tab] = getListData(privateAreaList, tab);
            });
            return result;
        };
        const tabListData = getTabListData(tabCodeList);
        this.setState({
            activeTabKey: tabKeyArr[0] && tabKeyArr[0].code,
            tabKeyArr,
            tabListData,
        });
    };

    //有多页签孙表的区域
    isGrandsonTab = area => {
        const isGrandson = item => item && item.grandsons && item.grandsons.find(g => g.tabs || g.tabheadcode);
        if(!area.tabs) {
            return isGrandson(area);
        }
    };

    //创建行数据
    createLaneItem = (data = []) => {
        data = Array.isArray(data) ? data : [data];
        return { checked: false, data };
    };

    handleHeadBtnClick = key => {
        switch (key) {
            //全选
            case 'checkAll':
                this.handleCheck('all');
                break;
            //取消全选
            case 'cancelAll':
                this.handleCheck('cancel');
                break;
            //新增楼层
            case 'addFloor':
                this.addLane();
                break;
            //合并楼层
            case 'mergeFloor':
                this.mergeFloor();
                break;
            //拆分楼层
            case 'splitFloor':
                this.splitFloor();
                break;
            default:
                break;
        }
    };

    //合并楼层
    mergeFloor = () => {
        let { tabListData, activeTabKey } = this.state;
        let checkedFloorList = this.getCheckedFloor().filter(item => item.data.length > 0);
        let tabArea = checkedFloorList[0] && checkedFloorList[0].data[0];
        let flatArea = [];
        checkedFloorList.forEach(item => {
            flatArea = flatArea.concat(item.data);
        });

        const newListData = tabListData[activeTabKey]
            .map(item => {
                if (item.checked) {
                    if (item.data[0] && item.data[0].code === tabArea.code) {
                        item.data = flatArea;
                    } else {
                        item = null;
                    }
                }
                return item;
            })
            .filter(item => item !== null); //删掉空行
        tabListData[activeTabKey] = newListData;
        this.updateTabListData(tabListData);
    };

    //拆分楼层
    splitFloor = () => {
        let { tabListData, activeTabKey } = this.state;
        let newListData = [];
        tabListData[activeTabKey].map(item => {
            //拆分选中行
            if (item.checked) {
                item.data.forEach(tab => {
                    newListData.push(this.createLaneItem(tab));
                });
            } else {
                newListData.push(item);
            }
        });
        tabListData[activeTabKey] = newListData;
        this.updateTabListData(tabListData);
    };

    //切换页签
    handleTabChange = key => {
        this.setState({ activeTabKey: key });
    };

    //选中泳道
    handleCheck = (value, laneIndex) => {
        let { tabListData } = this.state;
        tabListData[this.state.activeTabKey].map((item, index) => {
            const area = item.data[0];
            //全选
            if (value === 'all') {
                item.checked = true;
                //主表不选中
                if (area && area.areatype === '1' && area.code && area.code === area.headcode) {
                    item.checked = false;
                }
                //侧拉不选中
                if(area && checkAreaType.isSide(area)) {
                    item.checked = false;
                }
            } else if(value === 'cancel') { //取消全选
                item.checked = false;
            } else {
                if (laneIndex === index) {
                    item.checked = value;
                }
            }
        });
        this.updateTabListData(tabListData);
    };

    //获取选中楼层数据
    getCheckedFloor = () => {
        const { tabListData, activeTabKey } = this.state;
        if(Object.keys(tabListData).length === 0) {return [];}
        return tabListData[activeTabKey].filter(item => item.checked);
    };

    updateTabListData = data => {
        let tabListData = _.cloneDeep(data);
        this.setState({ tabListData });
    };

    //弹窗头部按钮
    renderHeadBtnArea = () => {
        let checkedFloorList = this.getCheckedFloor();
        const currentListData = this.state.tabListData[this.state.activeTabKey] || [];
        const btns = [
            {
                name: langCheck(
                    'ZoneSetting-000270',
                    'pages',
                    this.props.json,
                ) /* 国际化处理： 全选*/,
                code: 'checkAll',
                isshow: currentListData.length > 1 ? checkedFloorList.length !== currentListData.length - 1 : checkedFloorList.length === 0,
            },
            {
                name: langCheck(
                    'ZoneSetting-000326',
                    'pages',
                    this.props.json,
                ) /* 国际化处理： 取消全选*/,
                code: 'cancelAll',
                isshow: currentListData.length > 1 ? checkedFloorList.length === currentListData.length - 1 : checkedFloorList.length === currentListData.length,
            },
            {
                name: langCheck(
                    'ZoneSetting-000323',
                    'pages',
                    this.props.json,
                ) /* 国际化处理： 新增楼层*/,
                code: 'addFloor',
                isshow: true,
            },
            {
                name: langCheck(
                    'ZoneSetting-000324',
                    'pages',
                    this.props.json,
                ) /* 国际化处理： 合并楼层*/,
                code: 'mergeFloor',
                group: true,
                isshow: true,
                type: 'primary',
                disabled: checkedFloorList.length < 2,
            },
            {
                name: langCheck(
                    'ZoneSetting-000325',
                    'pages',
                    this.props.json,
                ) /* 国际化处理： 拆分楼层*/,
                code: 'splitFloor',
                group: true,
                isshow: true,
                disabled: checkedFloorList.length === 0 || checkedFloorList.every(item => item.data.length <= 1),
            },
        ];
        return (
            <div className="head-btns">
                <ButtonCreate dataSource={btns} onClick={this.handleHeadBtnClick} />
            </div>
        );
    };

    renderLayContent = listData => {
        return (
            <LaySetContent
                sourceData={listData}
                onChecked={this.handleCheck}
                onDeleteLane={this.deleteLane}
                dropLogic={this.dropLogic}
                dragLane={this.dragLane}
                json={this.props.json}
                multiOptions={this.props.multiOptions}
            />
        );
    }

    //渲染弹窗内容
    renderModalContent = () => {
        const { tabKeyArr, tabListData } = this.state;
        //只有一个页签不显示Tabs
        if(tabKeyArr.length === 1) {
            const tab = tabKeyArr[0];
            const listData = tabListData[tab.code];
            return (
                <React.Fragment>
                    <div className="tls-header">{this.renderHeadBtnArea()}</div>
                    {this.renderLayContent(listData)}
                </React.Fragment>
            );
        } else {
            return (
                <div className="tls-header">
                    <NCTabs
                        activeKey={this.state.activeTabKey}
                        className="tls-tabs"
                        extraContent={this.renderHeadBtnArea()}
                        onChange={this.handleTabChange}
                    >
                        {tabKeyArr.map(tab => (
                            <NCTabPane tab={tab.name} key={tab.code}>
                                {this.renderLayContent(tabListData[tab.code])}
                            </NCTabPane>
                        ))}
                    </NCTabs>
                </div>
            );
        }
    };

    /**
     *模态框确定按钮
     *
     * @memberof TabLaySetModal
     */
    showOkDialog = () => {
        this.formatTabListData();
        this.hiddenDialog();
    };

    //将tabListData转成areaList
    formatTabListData = () => {
        let { tabListData } = this.state;
        let localAreaList = _.cloneDeep(this.props.areaList);
        //得到相同区域类型的数据
        const getSameListData = (data, areatype) => {
            let result = [];
            const listData = _.cloneDeep(data);
            listData && listData.forEach(item => {
                const newData = item.data.filter(lane => lane.areatype === areatype);
                item.data = newData;
                if(newData.length > 0) {
                    result.push(item);
                }
            });
            return result;
        };
        //去除空行
        const removeEmptyData = data => {
            for (const key in data) {
                const newList = data[key].filter(item => item.data.length > 0);
                data[key] = newList;
            }
            return data;
        };
        tabListData = removeEmptyData(tabListData);
        for (const key in tabListData) {
            const listData = tabListData[key];
            const formListData = getSameListData(listData, '1'); //过滤表单区
            const tableListData = getSameListData(listData, '2'); //过滤表格区
            let tabCode = tableListData[0] && tableListData[0].data[0].code; //表格多页签第一个页签code
            let formTabCode; //主表页签code
            //主子表页签tabcode取表格区第一个页签
            if(key === DEFAULT_TAB_NAME && formListData.length) {
                formTabCode = formListData[0] && formListData[0].data[0].code;
            }
            listData.forEach((lane, laneIndex) => {
                const laneData = lane.data;
                const laneFirstArea = laneData[0]; //每行第一个页签
                const associatedtabCode = laneFirstArea && laneFirstArea.code; //多页签关联区域编码

                laneData.forEach((area, index) => {
                    const targetAreaIndex = localAreaList.findIndex(item => item.pk_area === area.pk_area);
                    const targetArea = localAreaList[targetAreaIndex];
                    if(targetArea.code === area.code) {
                        if(targetArea.code === tabCode || (formTabCode && targetArea.code === formTabCode)) {
                            //第一个页签删掉关联字段
                            targetArea.associatedtab = '';
                        } else {
                            //有多个页签关联associatedtab
                            if(laneData.length > 1) {
                                //主表多页签关联code
                                if(formTabCode && area.code !== formTabCode && targetArea.areatype === '1') {
                                    targetArea.associatedtab = formTabCode;
                                } else {
                                    if(area.code === associatedtabCode) {
                                        targetArea.associatedtab = ''; //清空每行第一个页签的associatedtab
                                    } else {
                                        targetArea.associatedtab = associatedtabCode;
                                    }
                                }
                            } else {
                                targetArea.associatedtab = '';
                            }
                        }
                    }

                    //根据页签顺序给areaList重新排序（把页签area放到第一个页签后面）
                    if(laneData.length > 1 && laneFirstArea.pk_area !== area.pk_area) {
                        const removeItem = localAreaList.splice(targetAreaIndex, 1)[0];
                        const prevArea = laneData[index - 1]; //前一个页签
                        const prevAreaIndex = localAreaList.findIndex(item => item.pk_area === prevArea.pk_area);
                        localAreaList.splice(prevAreaIndex + 1, 0, removeItem); //插到目标区域后面
                    } else if(laneIndex > 0){ //一行只有一个页签
                        const removeItem = localAreaList.splice(targetAreaIndex, 1)[0];
                        const prevLane = listData[laneIndex - 1]; //上一行
                        const prevArea = prevLane && prevLane.data[prevLane.data.length - 1]; //上一行最后一个页签
                        const prevAreaIndex = localAreaList.findIndex(item => item.pk_area === prevArea.pk_area);
                        localAreaList.splice(prevAreaIndex + 1, 0, removeItem); //插到目标区域后面
                    }
                });
            });
        }
        this.props.updateAreaList(localAreaList);
    }

    /**
     *模态框取消按钮
     *
     * @memberof TabLaySetModal
     */
    hiddenDialog = () => {
        this.props.setTabLayModalVisible(false);
    };

    /**
     *增加 泳道按钮
     *
     * @memberof TabLaySetModal
     */
    addLane = () => {
        let { tabListData } = this.state;
        const blankItem = this.createLaneItem();
        tabListData[this.state.activeTabKey].push(blankItem);
        this.updateTabListData(tabListData);
    };

    //删除泳道
    deleteLane = index => {
        let { tabListData } = this.state;
        tabListData[this.state.activeTabKey].splice(index, 1);
        this.updateTabListData(tabListData);
    };

    //页签拖拽排序 type:拖动类型 tag:页签 lane:泳道
    dropLogic = (type, { dragIndex, targetIndex, laneIndex, targetLaneIndex }) => {
        const { tabListData, activeTabKey } = this.state;
        const currentListData = tabListData[activeTabKey];
        const dragItem = currentListData[laneIndex] && currentListData[laneIndex].data[dragIndex]; //拖拽元素
        currentListData[laneIndex].data.splice(dragIndex, 1);
        //拖拽目标释放到泳道
        if (type === 'lane') {
            currentListData[targetLaneIndex].data.push(dragItem);
        } else if (type === 'tag') {
            //拖拽目标释放到标签
            currentListData[targetLaneIndex].data.splice(targetIndex, 0, dragItem);
        }
        this.updateTabListData(tabListData);
    };

    //拖拽泳道排序
    dragLane = (laneIndex, targetLaneIndex) => {
        let { tabListData } = this.state;
        const currentListData = tabListData[this.state.activeTabKey];
        if (Math.abs(laneIndex - targetLaneIndex) === 1) {
            [currentListData[laneIndex], currentListData[targetLaneIndex]] = [currentListData[targetLaneIndex], currentListData[laneIndex]]; //交换位置
        } else {
            let tmp = currentListData.splice(laneIndex, 1);
            tabListData[this.state.activeTabKey] = currentListData.slice(0, targetLaneIndex).concat(tmp, currentListData.slice(targetLaneIndex));

        }
        this.updateTabListData(tabListData);
    };

    render() {
        const { json, visible } = this.props;
        console.log('tabListData', this.state.tabListData);
        return (
            <div className="tls-container">
                <HotKeysModal
                    maskClosable={false}
                    customHeader={langCheck(
                        'ZoneSetting-000246',
                        'pages',
                        json,
                    )} /* 国际化处理： 页签布局设置*/
                    visible={visible}
                    onOk={this.showOkDialog}
                    onCancel={this.hiddenDialog}
                    className="tab-lay-modal"
                    size="xlg"
                    minHeight={500}
                    okText={langCheck('ZoneSetting-000005', 'pages', json)} /* 国际化处理： 确定*/
                    cancelText={langCheck(
                        'ZoneSetting-000006',
                        'pages',
                        json,
                    )} /* 国际化处理： 取消*/
                    fieldid="tabLaySet" //自动化测试标记
                >
                    {this.renderModalContent()}
                </HotKeysModal>
            </div>
        );
    }
}

export default connect(
    state => ({
        newAreaList: state.zoneSettingData.newAreaList,
        visible: state.zoneSettingData.showTabLaySetModal,
        areaList: state.zoneSettingData.areaList,
        zoneFormData: state.zoneSettingData.zoneFormData,
    }),
    {
        setTabLayModalVisible,
        updateAreaList,
    },
)(TabLaySetModal);
